// @ts-nocheck
import { escapeXMLAttributeValue, escapeXMLCharacterData, interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass, WithTagName } from "./Dom";
import { ConfirmationClass, ConfirmationWindowComponent } from "./WebApp.ConfirmationWindow";
import { RequestQueue, XmlMessage } from "./WebApp.Request.Queue";
import { Labels, WebPageComponent } from "./WebSite.Page.Component";

function Message(element) {
  this.determineChildren = function () {
    var messageElements = new DomQuery(new DomQuery(this.element).getChild(WithClass("Messages"))).getChildren(WithClass("Message"));

    for (var index = 0; index < messageElements.length; index++)
      this.children.push(new Message(messageElements[index]));
  }

  this.getLastMessage = function () {
    if (this.children.length > 0)
      return this.children[this.children.length - 1].getLastMessage();
    else
      return this;
  }

  this.getMessageWithId = function (id) {
    if (this.id === id)
      return this;
    else {
      var result = null;
      var index = 0;

      while (result === null && index < this.children.length) {
        result = this.children[index].getMessageWithId(id);
        index++;
      }

      return result;
    }
  }

  this.getMessageList = function () {
    var messages = new Array();

    for (var index = 0; index < this.children.length; index++) {
      var message = this.children[index];
      messages.push(message);
      messages = messages.concat(message.getMessageList());
    }

    return messages;
  }

  this.attachClickHandlers = function () {
    var object = this;

    this.contentsElement.onclick = function (event) {
      object.selected.toggle();

      if (object.listener !== null)
        object.listener(object);
    }
  }

  this.element = element;
  this.id = element.dataset.Id;
  this.children = new Array();

  this.determineChildren();
  this.contentsElement = new DomQuery(this.element).getChild(WithClass("Contents"));
  this.selected = new HtmlClassSwitch(this.element, "Selected");
  this.attachClickHandlers();
}

export class MessageThreadAddMessage extends XmlMessage {
  constructor(target, content) {
    super();

    this.target = target;
    this.content = content;
  }

  toXml() {
    return "<Add Target=\"" + escapeXMLAttributeValue(this.target) + "\">" + escapeXMLCharacterData(this.content) + "</Add>";
  }
}

export class MessageThreadDeleteMessages extends XmlMessage {
  constructor() {
    super();

    this.ids = new Array();
  }

  toXml() {
    let result = "<Delete>";

    for (let index = 0; index < this.ids.length; index++)
      result += "<Message Id=\"" + this.ids[index] + "\"/>";

    result += "</Delete>";
    return result;
  }

  add(id) {
    this.ids.push(id);
  }
}

export class MessageThreadRenderMessage extends XmlMessage {
  constructor(content) {
    super();

    this.content = content;
  }

  toXml() {
    return "<Render/>";
  }
}

export class MessageThread extends WebPageComponent {
  constructor(element) {
    super(element);

    this.id = element.dataset.Id;
    this.uri = element.dataset.Uri;
    this.inputArea = null;
    this.inputButton = null;
    this.requestQueue = new RequestQueue(this);
    this.messages = new Array();
    this.progressSwitch = new HtmlClassSwitch(this.element, "InProgress");
    this.toolbarSwitch = null;
    this.replySwitch = null;

    this.addInputArea();
    this.determineMessages();
  }

  async handleRenderResponse(response, messageId) {
    const newContents = document.createElement("div");
    newContents.innerHTML = await response.text();

    const newThreadElement = newContents.firstChild;
    this.threadElement.innerHTML = newThreadElement.innerHTML;

    this.determineMessages();
    this.addListener();
    this.messageSelectionChanged();

    this.scrollTo(this.getMessageWithId(messageId));
    this.progressSwitch.setStatus(false);
  }

  async handleAddResponse(response) {
    this.inputArea.value = "";

    const element = new DOMParser().parseFromString(await response.text(), "application/xml").documentElement;
    let messageId = null;

    if (element.tagName === "Message")
      messageId = element.getAttribute("Id");

    this.requestQueue.queue(
      this.uri,
      "POST",
      new MessageThreadRenderMessage(),
      null,
      (response) => this.handleRenderResponse(response, messageId)
    );
  }

  addMessage() {
    const content = this.inputArea.value;

    if (content !== "") {
      const selectedMessages = this.getSelectedMessages();
      let target = "";

      if (selectedMessages.length === 0)
        target = this.id;
      else if (selectedMessages.length === 1)
        target = selectedMessages[0].id;

      if (target !== "") {
        this.progressSwitch.setStatus(true);

        this.requestQueue.queue(
          this.uri,
          "POST",
          new MessageThreadAddMessage(target, content),
          null,
          (response) => this.handleAddResponse(response)
        );
      }
    }
  }

  createAddMessageHandler() {
    return (event) => {
      this.addMessage();
    };
  }

  addInputArea() {
    this.inputArea = document.createElement("textarea");

    this.inputButton = document.createElement("input");
    this.inputButton.className = "Add";
    this.inputButton.type = "button";
    this.inputButton.onclick = this.createAddMessageHandler();

    this.inputDivision = document.createElement("div");
    this.inputDivision.className = "Input";
    this.inputDivision.appendChild(this.inputArea);
    this.inputDivision.appendChild(this.inputButton);

    this.element.appendChild(this.inputDivision);
    this.replySwitch = new HtmlClassSwitch(this.inputDivision, "Reply");
  }

  determineMessages() {
    const messageElements = new DomQuery(new DomQuery(this.element).getChild(WithClass("Contents"))).getChildren(WithClass("Message"));
    this.messages = new Array();

    for (const messageElement of messageElements)
      this.messages.push(new Message(messageElement));
  }

  getLastMessage() {
    if (this.messages.length > 0)
      return this.messages[this.messages.length - 1].getLastMessage();
    else
      return null;
  }

  getMessageWithId(id) {
    let result = null;
    let index = 0;

    while (result === null && index < this.messages.length) {
      result = this.messages[index].getMessageWithId(id);
      index++;
    }

    return result;
  }

  getMessageList() {
    let messages = new Array();

    for (const message of this.messages) {
      messages.push(message);
      messages = messages.concat(message.getMessageList());
    }

    return messages;
  }

  addListener() {
    const messageList = this.getMessageList();
    const listener = this.createListener();

    for (const message of messageList)
      message.listener = listener;
  }

  scrollTo(message) {
    if (message !== null) {
      const messageContents = new DomQuery(message.element).getChild(WithClass("Contents"));
      const messageRectangle = messageContents.getBoundingClientRect();

      const threadRectangle = this.threadElement.getBoundingClientRect();
      const delta = messageRectangle.bottom - threadRectangle.top - threadRectangle.height + 14;

      this.threadElement.scrollTop += delta;
    }
  }

  handleDeleteResponse(response) {
    this.requestQueue.queue(
      this.uri,
      "POST",
      new MessageThreadRenderMessage(),
      null,
      (response) => this.handleRenderResponse(response, "") // TODO: Is this correct for MessageId?
    );
  }

  deleteMessages() {
    const message = new MessageThreadDeleteMessages();
    const selectedMessages = this.getSelectedMessages();

    for (const selected of selectedMessages)
      message.add(selected.id);

    this.progressSwitch.setStatus(true);
    this.requestQueue.queue(
      this.uri,
      "POST",
      message,
      null,
      (response) => this.handleDeleteResponse(response)
    );
  }

  bind() {
    let query = new DomQuery(this.element);

    this.toolbarElement = query.getChild(WithClass("Toolbar"));
    this.threadElement = query.getChild(WithClass("Contents"));

    query = new DomQuery(this.toolbarElement);

    this.countElement = query.getChild(WithClass("Count"));
    this.deleteAction = query.getChild(WithClass("Delete"));

    query = new DomQuery(this.deleteAction);

    this.deleteButton = query.getChild(WithTagName("INPUT"));
    this.deleteButton.addEventListener("click", (event) => { this.confirmationWindow.show(); });

    const confirmationLabels = new Labels(query.getChild(WithClass("Labels")));

    this.confirmationWindow = new ConfirmationWindowComponent(confirmationLabels.Confirmation, confirmationLabels.Confirm, confirmationLabels.Cancel, () => this.deleteMessages(), ConfirmationClass.Delete);
    this.toolbarSwitch = new HtmlClassSwitch(this.toolbarElement, "Visible");
    this.scrollTo(this.getLastMessage());

    new HtmlClassSwitch(this.threadElement, "Loaded").setStatus(true);
    this.addListener();
  }

  getSelectedMessages() {
    const messages = this.getMessageList();
    const selectedMessages = new Array();

    for (const message of messages) {
      if (message.selected.getStatus())
        selectedMessages.push(message);
    }

    return selectedMessages;
  }

  enableInput(enabled) {
    this.inputArea.disabled = !enabled;
    this.inputButton.disabled = !enabled;
  }

  messageSelectionChanged() {
    const selectedMessages = this.getSelectedMessages();

    this.toolbarSwitch.setStatus(selectedMessages.length > 0);
    this.replySwitch.setStatus(selectedMessages.length > 0);

    this.countElement.innerHTML = selectedMessages.length;
    this.enableInput(selectedMessages.length <= 1);
  }

  createListener() {
    return (message) => {
      this.messageSelectionChanged();
    };
  }

  handleError(error) {
    // TODO: Implement.
  }
}

interactivityRegistration.register("MessageThread", function (element) { return new MessageThread(element); });
